export enum ApplicationStatusReason {
    EMPLOYEE_EXIT = 'EMPLOYEE_EXIT',
    INELIGIBLE_EMPLOYEE_GROUP = 'INELIGIBLE_EMPLOYEE_GROUP',
    INVALID_TRAVEL_DURATION = 'INVALID_TRAVEL_DURATION'
}
